module.exports = __webpack_public_path__ + "media/images/logos/apple-light-a5cdddac300390a534e2401f7774cde8.svg";